import Footer, { FooterTheme } from './Footer';

export default function LoggedFooter() {
  return <Footer theme={FooterTheme.DARK} />;
}
